import React from 'react';
import { TableCell, Stack, Typography, Skeleton } from '@mui/material';
import { UserAvatar } from '@/components/UserAvatar';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

const OwnerCell = ({ userId, email, ...params }) => {
	return (
		<TableCell>
			<OwnerCellData {...{ userId, email, ...(params ?? {}) }} />
		</TableCell>
	);
};

// userId is the user's Firestore doc id.
export const OwnerCellData = ({ email, userId, fallbackName = '', ...params }) => {
	const { data: userDetails, ...userQuery } = useGetUserDetailsQuery(
		{ email, userId },
		{
			skip: !email && !userId,
		},
	);

	const { firstName, lastName, name } = userDetails ?? {};

	const fullName = (firstName ? `${firstName} ${lastName}` : name) || fallbackName || email;

	return (
		<Stack direction='row' spacing={1} alignItems={'center'} width={'100%'}>
			{userDetails && <UserAvatar userId={userDetails.userId} />}
			{userQuery.isLoading ? (
				<Skeleton variant='text' width='100%' />
			) : (
				<Typography sx={{ color: params?.color }}>{fullName}</Typography>
			)}
		</Stack>
	);
};

export default OwnerCell;
